export const EMPTY_FUNNEL_PERIOD = {
  start: null,
  end: null,
  newUsers: 0,
  newUsersPrev: 0,
  newUsersDeltaPct: 0,
  joined: 0,
  joinRate: 0,
  activation: {
    activated: 0,
    activatedAll: 0,
    activated7: 0,
    rate: 0,
    rate7: 0,
    fromJoinedRate: 0,
    timeAvgMin: null,
    timeMedianMin: null,
    p50: null,
    p75: null,
    p90: null
  },
  aha: {
    users: 0,
    rateFromActivated: 0,
    avgRequestsDay1: 0,
    noAhaRate: 0
  },
  paywall: {
    viewUsers: 0,
    rateFromAha: 0,
    avgViewsBeforePurchase: 0,
    medianViewsBeforePurchase: 0,
    dist: { one: 0, twoThree: 0, fourPlus: 0 }
  },
  checkout: {
    openUsers: 0,
    rateFromPaywall: 0
  },
  purchase: {
    users: 0,
    usersWithAha: 0,
    usersWithoutAha: 0,
    events: 0,
    crPaywallPurchase: 0,
    crCheckoutPurchase: 0,
    crAhaPurchase: 0,
    ahaLag: { samples: 0, avgDays: 0, medianDays: 0, day0: 0, day1: 0, day3: 0, day7: 0 }
  }
};

export const EMPTY_PRODUCT_BREAKDOWN = {
  lite: { count: 0, revenue: 0 },
  pro: { count: 0, revenue: 0 },
  max: { count: 0, revenue: 0 },
  tokens: { count: 0, revenue: 0 },
  roulette: { count: 0, revenue: 0 },
  photosession: { count: 0, revenue: 0 },
  photoAnimation: { count: 0, revenue: 0 },
  ocr: { count: 0, revenue: 0 },
  music: { count: 0, revenue: 0 },
  other: { count: 0, revenue: 0 }
};

export const EMPTY_MONEY_PERIOD = {
  revenue: 0,
  purchases: 0,
  purchaseUsers: 0,
  purchaseUsersPaid: 0,
  arppu: 0,
  arppuAll: 0,
  parentPayment: { revenue: 0, purchases: 0, users: 0 },
  tokens: 0,
  cost: 0,
  margin: 0,
  bySource: { vkdonut: 0, cloudpayments: 0, tochka: 0, unitpay: 0, yookassa: 0, other: 0 },
  bySourcePurchases: { vkdonut: 0, cloudpayments: 0, tochka: 0, unitpay: 0, yookassa: 0, other: 0 },
  byPlan: {
    lite: { count: 0, revenue: 0 },
    pro: { count: 0, revenue: 0 },
    max: { count: 0, revenue: 0 }
  },
  byProduct: { ...EMPTY_PRODUCT_BREAKDOWN },
  renewals: 0,
  subscriptions: {
    new: { users: 0, events: 0, revenue: 0 },
    renewals: { users: 0, events: 0, revenue: 0 },
    total: { users: 0, events: 0, revenue: 0 }
  },
  oneTime: { users: 0, events: 0, revenue: 0 },
  paymentFails: 0,
  subscriptionCancels: 0
};

export const EMPTY_PURCHASE_SERIES = {
  start: null,
  end: null,
  unit: "purchase_events",
  labels: [],
  series: [
    { key: "lite", label: "Lite", data: [], total: 0 },
    { key: "pro", label: "Pro", data: [], total: 0 },
    { key: "max", label: "Max", data: [], total: 0 },
    { key: "oneTime", label: "Разовые", data: [], total: 0 },
    { key: "other", label: "Другое", data: [], total: 0 }
  ]
};

export const EMPTY_REQUESTS_PERIOD = {
  totalRequests: 0,
  rows: [],
  insights: []
};

export const EMPTY_ANALYTICS = {
  generatedAt: null,
  updatedAt: null,
  refreshing: false,
  stale: false,
  error: null,
  meta: {
    labels: {
      periods: "cohort",
      rollingPeriods: "trailing"
    }
  },
  periods: {
    day: { ...EMPTY_FUNNEL_PERIOD },
    week: { ...EMPTY_FUNNEL_PERIOD },
    month: { ...EMPTY_FUNNEL_PERIOD }
  },
  rollingPeriods: {
    day: { ...EMPTY_FUNNEL_PERIOD },
    week: { ...EMPTY_FUNNEL_PERIOD },
    month: { ...EMPTY_FUNNEL_PERIOD }
  },
  dropOff: { steps: [], bottleneck: null },
  money: {
    day: { ...EMPTY_MONEY_PERIOD },
    week: { ...EMPTY_MONEY_PERIOD },
    month: { ...EMPTY_MONEY_PERIOD },
    activePaid: 0,
    activeByPlan: { lite: 0, pro: 0, max: 0 },
    activeSubscriptions: {
      total: 0,
      paid: 0,
      gifted: 0,
      legacy: 0,
      unknown: 0,
      byPlan: {
        total: { lite: 0, pro: 0, max: 0 },
        paid: { lite: 0, pro: 0, max: 0 },
        gifted: { lite: 0, pro: 0, max: 0 },
        legacy: { lite: 0, pro: 0, max: 0 },
        unknown: { lite: 0, pro: 0, max: 0 }
      }
    },
    newPayersMonth: 0,
    avgTimeToFirstPurchaseDays: 0,
    repeatPurchaseCount: 0,
    repeatPurchaseRate: 0,
    renewRate: 0,
    revenueFromOldUsersShare: 0,
    lifecycleDays: 0,
    avgMonths: 0,
    ltv: 0,
    cac: 0,
    ltvToCac: 0,
    avgWeeklyNewPayers: 0,
    goalWeeks: 0
  },
  retention: { d1: 0, d7: 0, d30: 0 },
  cohorts: { rows: [], insights: [] },
  roles: {
    newUsers: { total: 0, roles: { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0 }, shares: { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0 } },
    payers: { total: 0, roles: { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0 }, shares: { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0 } }
  },
  requests: {
    day: { ...EMPTY_REQUESTS_PERIOD },
    week: { ...EMPTY_REQUESTS_PERIOD },
    month: { ...EMPTY_REQUESTS_PERIOD },
    allTime: { ...EMPTY_REQUESTS_PERIOD }
  },
  weekly: {
    purchaseTypes: {
      subscriptionNew: { users: 0, events: 0, revenue: 0, rate: 0 },
      oneTime: { users: 0, events: 0, revenue: 0, rate: 0 }
    },
    entryPoints: { rows: [], bestConversion: null, bestAvgCheck: null },
    purchaseSeries: { ...EMPTY_PURCHASE_SERIES },
    roles: {
      school: { users: 0, payers: 0, payRate: 0, subsRevenue: 0, oneTimeRevenue: 0 },
      other: { users: 0, payers: 0, payRate: 0, subsRevenue: 0, oneTimeRevenue: 0 }
    },
    oneTimeToSubscription: { oneTimeUsers: 0, converted7: 0, converted30: 0, rate7: 0, rate30: 0 },
    subscriptions: {
      new: { users: 0, events: 0, revenue: 0 },
      renewals: { users: 0, events: 0, revenue: 0 },
      cancellations: 0,
      net: 0,
      byTariff: []
    }
  },
  executiveSummary: [],
  conclusions: { bottleneck: null, growthMetric: null, focus: null, goalWeeks: 0 },
  dashboard: { date: "", text: "" }
};

export const ROLE_LABELS = {
  1: "🎓 Школьник/студент",
  2: "✌️ Создаю контент/работаю",
  3: "💼 Бизнес/предприниматель",
  4: "🤷 Другое",
  0: "Не выбрали"
};

export const PRODUCT_GROUP_LABELS = [
  { key: "lite", label: "Lite (Лайт)" },
  { key: "pro", label: "Pro (Про)" },
  { key: "max", label: "Max (Макс)" },
  { key: "tokens", label: "Токены (пакеты)" },
  { key: "roulette", label: "Рулетка" },
  { key: "photosession", label: "Фотосессия" },
  { key: "photoAnimation", label: "Оживить фото" },
  { key: "ocr", label: "Решение по фото" },
  { key: "music", label: "Музыка" },
  { key: "other", label: "Другое" }
];

export const ENTRY_POINT_LABELS = {
  menu: "menu (меню)",
  after_aha: "after_aha (после Aha)",
  tokens_low: "tokens_low (мало токенов)",
  tokens_zero: "tokens_zero (0 токенов)",
  after_photosession_result: "after_photosession_result (фотосессия)",
  after_photo_task_result: "after_photo_task_result (OCR)",
  after_limit_hit: "after_limit_hit (лимиты/очередь)",
  push: "push",
  wheel: "wheel (рулетка)",
  unknown: "unknown"
};

export const PURCHASE_SERIES_COLORS = {
  lite: "#76F2C2",
  pro: "#FF7B72",
  max: "#7CE7FF",
  oneTime: "#FFD166",
  other: "#A0AEC0"
};

export const ROULETTE_ACCENT_PRESETS = [
  "#7CE7FF",
  "#76F2C2",
  "#6CDBFF",
  "#8EF6A8",
  "#FFD2F5",
  "#FFB86B",
  "#FF6B6B",
  "#FF7BC7",
  "#A084FF",
  "#FFD166"
];

export const ROULETTE_ICON_PRESETS = [
  "/roulette/tokens.svg",
  "/roulette/discount.svg",
  "/roulette/jackpot.svg",
  "/roulette/lite.svg",
  "/roulette/pro.svg",
  "/roulette/premium.svg",
  "/roulette/ruble.svg",
  "/roulette/sticker.svg"
];

export const TEMPLATE_EMOJI_PRESETS = [
  "⚡",
  "🎓",
  "✌️",
  "💼",
  "🎨",
  "🧠",
  "📈",
  "🛠️",
  "📚",
  "🎯",
  "🔥",
  "✅",
  "🤖",
  "📝",
  "📊",
  "💡"
];
